import Api from "../Api.js";

export const listQuotes = () => {
  return Api.get("quote").then((res) => res.data);
};

export const viewQuote = (id) => {
  return Api.get(`quote/${id}`).then((res) => res.data);
};

export const assignSuppliersToQuote = (id, data) => {
  return Api.post(`quote/${id}/assign-suppliers`, data).then((res) => res.data);
};

export const updateSupplierQuote = (quoteId, supplierId, data) => {
  return Api.post(`quote/${quoteId}/supplier/${supplierId}`, data).then(
    (res) => res.data
  );
};

export const getSupplierQuote = (quoteId, supplierId) => {
  return Api.get(`quote/${quoteId}/supplier/${supplierId}`).then(
    (res) => res.data
  );
};

export const sendToCustomer = (quoteId, data) => {
  return Api.post(`quote/${quoteId}/send-to-customer`, data).then(
    (res) => res.data
  );
};
